// src/components/dashboard/FilterBar.jsx

import React from 'react';
import { Icons } from './Icons';
import {
  Button,
  RefreshButton,
  PAGE,
  getSearchInputStyle,
  getToolbarStyle,
} from '../ui';

export default function FilterBar({
  searchTerm,
  onSearchChange,
  refreshing = false,
  onClear,
  onRefresh,
}) {
  return (
    <div
      style={{
        ...getToolbarStyle(),
        marginBottom: PAGE.sectionGap,
        gap: 12,
      }}
    >
      <div
        style={{
          display: 'flex',
          gap: 12,
          flexWrap: 'wrap',
          flex: 1,
          alignItems: 'center',
        }}
      >
        <div
          style={{
            position: 'relative',
            width: 320,
            maxWidth: '100%',
          }}
        >
          <span
            style={{
              position: 'absolute',
              left: 14,
              top: '50%',
              transform: 'translateY(-50%)',
              display: 'flex',
              alignItems: 'center',
              color: PAGE.colors.muted,
            }}
          >
            <Icons.search />
          </span>

          <input
            type="text"
            placeholder="Search assets…"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            style={{
              ...getSearchInputStyle('100%'),
              width: '100%',
              paddingLeft: 44,
            }}
          />
        </div>
      </div>

      {searchTerm && (
        <Button variant="dangerSoft" onClick={onClear} disabled={refreshing}>
          <Icons.clear /> Clear
        </Button>
      )}

      <RefreshButton onClick={onRefresh} refreshing={refreshing} />
    </div>
  );
}